<div class="product-delivery-moment" data-test="product-delivery-moment">
  <ng-container *ngIf="selectableDeliveryMoments?.deliveryTimeWindows?.length > 0 && deliveryTimeWindow?.invalid">
    <div class="product-delivery-moment__error notification notification-error text--input-small" data-test="product-delivery-moment__input-error">
      <mat-icon>error</mat-icon>
      {{ 'product.wizard.delivery-moment.error-delivery-time-window' | translate }}
    </div>
  </ng-container>

  <ng-container *ngIf="selectableDeliveryMoments">
    <app-delivery-date-weekend-warning></app-delivery-date-weekend-warning>

    <div
      class="product-delivery-moment__error notification notification-error text--input-small"
      data-test="product-delivery-moment__invalid-delivery-moment"
      *ngIf="calendar.selected ? !dateIsADeliveryDate($any(calendar.selected)) : false"
    >
      <mat-icon>error</mat-icon>
      {{ 'product.wizard.delivery-moment.error-invalid-delivery-moment' | translate }}
    </div>
  </ng-container>

  <div [hidden]="selectableDeliveryMoments === null">
    <mat-calendar
      class="product-delivery-moment__calendar"
      #calendar
      [minDate]="firstDeliveryDate"
      [maxDate]="lastDeliveryDate"
      startView="month"
      (selectedChange)="changeDate($event)"
    ></mat-calendar>
  </div>

  <ng-container *ngIf="selectableDeliveryMoments">
    <div class="spacing--margin-vertical">
      <mat-divider></mat-divider>
    </div>
    <div class="product-delivery-moment__title text--bold spacing--margin-bottom">
      {{ 'product.wizard.delivery-moment.delivery-title' | translate }}
    </div>
    <div class="product-delivery-moment__chips spacing--margin-top">
      <mat-chip-listbox class="product-delivery-moment__options" [selectable]="true">
        <ng-container *ngFor="let n of allowedFlexibility + 1 | range">
          <mat-chip-option
            (click)="changeFlexibility(n)"
            (keydown.enter)="changeFlexibility(n)"
            [selected]="flexibility === n"
            [attr.data-test]="'product-delivery-moment__' + n"
            [selectable]="false"
          >
            <mat-icon class="product-delivery-moment__options__icon" *ngIf="flexibility === n">check</mat-icon>
            <span class="spacing--padding-half-horizontal" *ngIf="n !== 0; else fixedDeliveryDate">
              {{ 'product.wizard.delivery-moment.flexible-delivery-text' | translate: { numberOfDays: n + 1 + '' } }}
            </span>
          </mat-chip-option>
        </ng-container>
      </mat-chip-listbox>

      <div class="product-delivery-moment__description spacing--margin-vertical">
        {{ 'product.wizard.delivery-moment.delivery-date-description' | translate }}
      </div>
    </div>

    <ng-template #fixedDeliveryDate>
      <span class="spacing--padding-half-horizontal">
        {{ 'product.wizard.delivery-moment.fixed-delivery-text' | translate }}
      </span>
    </ng-template>

    <ng-container *ngIf="selectableDeliveryMoments?.deliveryTimeWindows?.length > 0 && env.DELIVERY_TIME_WINDOW_DISABLED === false">
      <div class="spacing--margin-vertical">
        <mat-divider></mat-divider>
      </div>
      <div class="text--bold spacing--margin-bottom">
        {{ 'product.wizard.delivery-moment.delivery-time-window-title' | translate }}
      </div>
      <mat-form-field class="product-delivery-moment__time-window" data-test="product-delivery-moment__time-window">
        <mat-label>
          {{ 'product.wizard.delivery-moment.select-delivery-time-window' | translate }}
        </mat-label>
        <mat-select [formControl]="deliveryTimeWindow" [compareWith]="compareDeliveryTimeWindows">
          <mat-option *ngFor="let window of selectableDeliveryMoments?.deliveryTimeWindows" [value]="window">
            {{ window | formatTimeWindow }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </ng-container>

  <div
    class="product-delivery-moment__loading flex--row flex--justify-center flex--align-center spacing--margin-vertical"
    data-test="product-delivery-moment__loading"
    *ngIf="loading"
  >
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <ng-container *ngIf="loading === false && selectableDeliveryMoments === null">
    <div
      class="product-delivery-moment__warning notification notification-warning text--input-small"
      data-test="product-delivery-moment__no-delivery-moments-warning"
    >
      <mat-icon>warning</mat-icon>
      {{ 'product.wizard.delivery-moment.failure-delivery-moment' | translate }}
    </div>
  </ng-container>
</div>
